export default __webpack_public_path__ + "static/testimonial-2-8782b08e1843289229b2bbac103b6c9c.jpg";